import React from "react";
import Contactus1 from "../components/Contactus/Contactus1";
import Contactus2 from "../components/Contactus/Contactus2";

const Contactus = () => {
  return (
    <div className="w-full flex flex-col items-center ruler">
      <Contactus1 />
      <Contactus2 />
    </div>
  );
};

export default Contactus;
